const theme = (isDarkMode) =>({
    palette: {
        mode: isDarkMode ? "dark" : "light",
        primary: {
          main: '#3E73DB',
          light: '#91AFE9',
          dark: '#26ce96',
        },
        secondary: {
          main: '#BDE991',
          dark: '#9BDE58',
          light: '#ff8975',
        },
        background: {
          secondary: "#F0F4F9"
        },
        borderColor: {
          primary: "#C0C0C0"
        }
      },
});
export default theme;